import { render, staticRenderFns } from "./clientShow.vue?vue&type=template&id=27f99d77&"
import script from "./clientShow.vue?vue&type=script&lang=js&"
export * from "./clientShow.vue?vue&type=script&lang=js&"
import style0 from "./clientShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports